import { useContext } from "react";

// Components
import Triangle from "../Triangle";
import ChartCross from "../../ChartCross";
import Circle from "../../Circle";
import ColoredCircle from "../../ColoredCircle";
import Square from "../../Square";
import Loader from "../../../../components/UI/Loader";

// Styles
import styles from "../index.module.css";

// Utilities
import {
  calculateXPaddingNumberGraph,
  calculateYPaddingNumberGraph,
} from "../../../../utils/examReportsHelper";
import { ValidatePDFContext } from "../../../../contexts/ValidatePDFContext";
import { eyeTypes } from "../../../../enums";

const RLFastGraph = ({
  eye,
  pressedPoints,
  gridType,
  shouldDisplayTriangle = true,
  isLiveUpdate = null,
}) => {
  const { eyeLeft } = eyeTypes;
  const { forBackendPdf } = useContext(ValidatePDFContext);

  const scale = 1;

  // Show loader while data is not yet processed
  if (pressedPoints.length === 0) {
    return <Loader containerHeight="312px" />;
  }

  return (
    <main className={styles.container}>
      <ChartCross
        gridType={gridType}
        width={312 * scale}
        height={312 * scale}
        tickSize={6 * scale}
      />

      {/* blind spot */}
      {shouldDisplayTriangle && (
        <div
          style={{
            position: "absolute",
            marginTop: forBackendPdf ? 124 * (scale + 0.05) : 124,
            // If it's the left eye, the triangle should be placed at the left side of the grid. If it's right, at the right side of the grid.
            marginLeft: (140 + (eye === eyeLeft ? -71 : 91)) * scale,
          }}
        >
          <Triangle />
        </div>
      )}

      {pressedPoints
        .filter((spot) => spot.seen === false && spot.completed)
        .map((spot, i) => {
          return (
            <div
              key={i}
              style={{
                position: "absolute",
                paddingLeft: calculateXPaddingNumberGraph(spot.x),
                paddingTop: calculateYPaddingNumberGraph(spot.y),
              }}
            >
              <Square />
            </div>
          );
        })}
      {/* mapping the not completed visual spots. Display an orange circle by default, but display a green circle on the "current visual spot" */}
      {pressedPoints
        .filter((spot) => !spot.completed && spot.decibelValue) // considering the non completed ones, with a valid decibelValue/intensity
        .map((spot, i) => {
          return (
            <div
              key={i}
              style={{
                position: "absolute",
                paddingLeft: calculateXPaddingNumberGraph(spot.x),
                paddingTop: calculateYPaddingNumberGraph(spot.y),
              }}
            >
              {!isLiveUpdate ? "-" : <ColoredCircle isOrange={!spot.current} />}
            </div>
          );
        })}
      {/* mapping the completed visual spots (live update)*/}
      {/* It's used for report as a `seen` */}
      {pressedPoints
        .filter((spot) => spot.seen)
        .map((spot, i) => {
          return (
            <div
              key={i}
              style={{
                position: "absolute",
                paddingLeft: calculateXPaddingNumberGraph(spot.x),
                paddingTop: calculateYPaddingNumberGraph(spot.y),
              }}
            >
              <Circle />
            </div>
          );
        })}
    </main>
  );
};

export default RLFastGraph;
